import type { FC } from 'react';

import { WrapperHeader } from './HeaderDark.styles';

interface HeaderDarkProps {
  className?: string;
  children?: React.ReactNode;
}

const HeaderDark: FC<HeaderDarkProps> = ({ className, children }) => {
  return <WrapperHeader className={className}>{children}</WrapperHeader>;
};

export default HeaderDark;
